import { ALLOCATION_MAP_KEY } from '../analytics/constants'
import * as Sentry from '@sentry/browser'
import { Site } from '../types'

export const getFeatureFlags = () => {
  const alffRegex = /al_ff=([^\s;]+)/
  const alffMatch = document.cookie.match(alffRegex)
  if (alffMatch) {
    try {
      // Base64 conversion adds one or two `=` at the end of the resulting string when padding is needed.
      // This is encoded as `%3D` when it hits the user's cookies. Reverse this to ensure we can decode.
      const base64String = alffMatch[1].replace(new RegExp('%3D', 'g'), '=')
      // archie@edge encodes the feature flag object in base64.
      const jsonString = window.atob(base64String)
      return JSON.parse(jsonString)
    } catch (e) {
      Sentry.captureException(e)
    }
  }
  return {}
}

export const getAllocationMap = () => getFeatureFlags()[ALLOCATION_MAP_KEY]

export const getFileExtension = (filename: string): string | undefined => {
  const extRegex = /(?:\.([^.]+))?$/
  const fileExtension = extRegex.exec(filename)
  if (fileExtension) {
    return fileExtension[1]
  }
}

export interface WtJwt {
  cheggAccess: []
  cheggTokens: {
    access_token: string | null
    id_token: string | null
  }
  cheggUserUuid: string | null
  client: string
  email: string | null
  exp: number
  paidMember: boolean
  sessionId: string
  site: Site
  user_role: string
}

export const parseJwt = (token: string): WtJwt => {
  const base64Url = token.split('.')[1]
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
      })
      .join('')
  )

  return JSON.parse(jsonPayload)
}

export const getCharacterCount = (text: string): number => text.length

export const getWordCount = (text: string): number => text.trim().split(' ').length

export const getSubscriptionStatus = (isPaid: boolean) => (isPaid ? 'active' : 'non_member')

export const getAuthState = (cheggUserUuid: string | null) => (cheggUserUuid ? 'hard_logged_in' : 'logged_out')
